import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DrawerState {
  isNotificationDrawerOpen: boolean;
  isChatDrawerOpen: boolean;
  selectedChatId: number | null;
}

const initialState: DrawerState = {
  isNotificationDrawerOpen: false,
  isChatDrawerOpen: false,
  selectedChatId: null,
};

const drawerSlice = createSlice({
  name: "drawer",
  initialState,
  reducers: {
    openNotificationDrawer: (state) => {
      state.isNotificationDrawerOpen = true;
    },
    closeNotificationDrawer: (state) => {
      state.isNotificationDrawerOpen = false;
      state.isChatDrawerOpen = false;
      state.selectedChatId = null;
    },
    openChatDrawer: (state, action: PayloadAction<number>) => {
      state.isChatDrawerOpen = true;
      state.selectedChatId = action.payload;
    },
    closeChatDrawer: (state) => {
      state.isChatDrawerOpen = false;
      state.selectedChatId = null;
    },
    closeChatDrawerOnly: (state) => {
      state.isChatDrawerOpen = false;
      state.selectedChatId = null;
    },
    openNotificationAndChat: (state, action: PayloadAction<number>) => {
      state.isNotificationDrawerOpen = true;
      state.isChatDrawerOpen = true;
      state.selectedChatId = action.payload;
    },
  },
});

export const {
  openNotificationDrawer,
  closeNotificationDrawer,
  openChatDrawer,
  closeChatDrawer,
  closeChatDrawerOnly,
  openNotificationAndChat,
} = drawerSlice.actions;

export default drawerSlice;
